import { Card, Menu } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import ChartLoader from 'components/ChartLoader';
import { useTranslation } from 'react-i18next'

const OccupancyHistory = (props) => {
  const { t } = useTranslation()
  const [chartLoading, setChartLoading] = useState(true)
  const chartRef = useRef(null);
  const [option,setOption] = useState({
    xAxis: {
        max: 100,
    },
    yAxis: {
        type: "category",
        data: [t("location_history.month"), t("location_history.week"), t("location_history.day"), t("location_history.hour")],
    },
    legend: {
        data: [t("rooms.inBed"), t("inroom_analysis.in_room")],
    },
    series: [
        {
            name: t("rooms.inBed"),
            type: "bar", // Specify the chart type
            label: {
                show: true,
                position: 'right',
                valueAnimation: true,
                formatter: '{c} %',
            },
            data: [0,0,0,0], // Replace with actual data
        },
        {
            name: t("inroom_analysis.in_room"),
            type: "bar", // Specify the chart type
            label: {
                show: true,
                position: 'right',
                valueAnimation: true,
                formatter: '{c} %',
            },
            data: [0,0,0,0], // Replace with actual data
        }
    ],
})

  useEffect(() => {
    const chartInstance = chartRef.current.getEchartsInstance();

    const setGraphicImageSize = () => {
      
      if (props.data) {
        
        let inBedPctHour = parseFloat(props.data.DATA[0]['IN_BED_PCT_HOUR']) >= 100 ? 100 : parseFloat(props.data.DATA[0]['IN_BED_PCT_HOUR'])
        let inRoomPctHour = parseFloat(props.data.DATA[0]['IN_ROOM_PCT_HOUR']) >= 100 ? 100 : parseFloat(props.data.DATA[0]['IN_ROOM_PCT_HOUR'])
        let inBedPctDay = parseFloat(props.data.DATA[0]['IN_BED_PCT_DAY']) >=90 ? 90 : parseFloat(props.data.DATA[0]['IN_BED_PCT_DAY'])
        let inRoomPctDay = parseFloat(props.data.DATA[0]['IN_ROOM_PCT_DAY']) >= 90 ? 90 : parseFloat(props.data.DATA[0]['IN_ROOM_PCT_DAY'])
        let inBedPctWeek = parseFloat(props.data.DATA[0]['IN_BED_PCT_WEEK']) >= 90 ? 90 : parseFloat(props.data.DATA[0]['IN_BED_PCT_WEEK'])
        let inRoomPctWeek = parseFloat(props.data.DATA[0]['IN_ROOM_PCT_WEEK']) >= 90 ? 90 : parseFloat(props.data.DATA[0]['IN_ROOM_PCT_WEEK'])
        let inBedPctMonth = parseFloat(props.data.DATA[0]['IN_BED_PCT_MONTH']) >= 90 ? 90 : parseFloat(props.data.DATA[0]['IN_BED_PCT_MONTH'])
        let inRoomPctMonth = parseFloat(props.data.DATA[0]['IN_ROOM_PCT_MONTH']) >= 90 ? 90 : parseFloat(props.data.DATA[0]['IN_ROOM_PCT_MONTH'])
        chartInstance.setOption({
          series: [
            {
              name: t("rooms.inBed"),
              label: {
                show: true,
                position: 'right',
                valueAnimation: true,
                formatter: `{c} %`,
              },
              data: [inBedPctMonth, inBedPctWeek, inBedPctDay, inBedPctHour],
            },
            {
              name: t("inroom_analysis.in_room"),
              label: {
                show: true,
                position: 'right',
                valueAnimation: true,
                formatter: `{c} %`,
              },
              data: [inRoomPctMonth, inRoomPctWeek, inRoomPctDay, inRoomPctHour],
            }
          ],
        });
        setChartLoading(false)
      }
    };

    setGraphicImageSize();
    window.addEventListener('resize', setGraphicImageSize);
    return () => {
      window.removeEventListener('resize', setGraphicImageSize);
    };
  }, [props.data]);

  return (
    <Card 
      title={t("historyPage.occupancy_status_history")}
      style={{ height: "100%"}} 
      className='content-card'
      
    >
      {/* {
        props.option?<ReactECharts option={props.option}/>:<div style={{minHeight:'200px'}}/>
      } */}
      <ReactECharts style={{minHeight:400}} option={option} ref={chartRef} />
      {
        chartLoading && <ChartLoader/>
      }
    </Card>
  );
};

export default OccupancyHistory;